// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Router from "next/router";
import * as AuthStore$PorterinFeature from "../../../domain/store/AuthStore.mjs";
import * as AuthTextCmp$PorterinFeature from "../common/AuthTextCmp.mjs";
import * as LoginTncCmp$PorterinFeature from "./LoginTncCmp.mjs";
import * as LoginFormCmp$PorterinFeature from "./form/LoginFormCmp.mjs";
import * as AuthHeaderCmp$PorterinFeature from "../common/AuthHeaderCmp.mjs";
import * as LoginPictureCmp$PorterinFeature from "./LoginPictureCmp.mjs";
import * as CategoryAnalytics$PorterinFeature from "../../../../fare-estimate-v1/domain/helpers/CategoryAnalytics.mjs";
import * as AuthWrapperModuleScss from "../../styles/AuthWrapper.module.scss";
import * as CommonAnalyticsHelper$PorterinFeature from "../../../../../shared/core/helpers/CommonAnalyticsHelper.mjs";
import * as FareEstimateAnalyticsHelper$PorterinFeature from "../../../../fare-estimate-v1/domain/helpers/FareEstimateAnalyticsHelper.mjs";

var styles = AuthWrapperModuleScss;

function LoginCmp(Props) {
  var set_auth_state = Props.set_auth_state;
  var close_modal = Props.close_modal;
  var show_close_iconOpt = Props.show_close_icon;
  var login_form_state = Props.login_form_state;
  var show_close_icon = show_close_iconOpt !== undefined ? show_close_iconOpt : true;
  var match = React.useState(function () {
        return false;
      });
  var isInputInFocus = match[0];
  var router = Router.useRouter();
  var match$1 = login_form_state.login_form_input;
  var mobile = match$1 !== undefined ? match$1.mobile : "";
  React.useEffect((function () {
          var timeout_id = setTimeout((function (param) {
                  CommonAnalyticsHelper$PorterinFeature.publishPageLandEventWithParameter(CategoryAnalytics$PorterinFeature.getCategoryName(router), AuthStore$PorterinFeature.Login.ga_page_landing, AuthStore$PorterinFeature.Login.moe_page_landing_parameter, FareEstimateAnalyticsHelper$PorterinFeature.getFareSelectedCardVersionEventPayload(mobile));
                }), 0);
          return (function (param) {
                    clearTimeout(timeout_id);
                  });
        }), []);
  return React.createElement("div", {
              className: styles.wrapper
            }, React.createElement(AuthHeaderCmp$PorterinFeature.make, {
                  show_close_icon: show_close_icon,
                  close_modal: close_modal
                }), React.createElement(LoginPictureCmp$PorterinFeature.make, {
                  hide_image: isInputInFocus
                }), React.createElement("div", {
                  className: isInputInFocus ? styles["in-focus"] : styles["focus-false"]
                }), React.createElement(AuthTextCmp$PorterinFeature.make, {
                  heading: AuthStore$PorterinFeature.Login.modal_heading,
                  sub_heading: AuthStore$PorterinFeature.Login.modal_subheading
                }), React.createElement(LoginFormCmp$PorterinFeature.make, {
                  set_auth_state: set_auth_state,
                  set_is_input_in_focus: match[1],
                  login_form_state: login_form_state
                }), React.createElement(LoginTncCmp$PorterinFeature.make, {}));
}

var make = LoginCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
